import { useState } from "react";
import ArrowRight from "../../../components/LogoSVG/ArrowRight";

import githubLogo from "../../../public/github.svg";

function LinKProjectItem({ url, name }: any) {
  const [hoverArrow, setHoverArrow] = useState(false);

  return (
    <div>
      <a
        className="flex flex-row flex-wrap items-center mb-1 font-normal"
        onMouseEnter={() => setHoverArrow(true)}
        onMouseLeave={() => setHoverArrow(false)}
        href={url}
        target="_blank"
      >
        {name == "Github" ? (
          <>
            <div
              className={`mr-2  ${hoverArrow === true ? "" : "text-gray-5"}`}
            >
              {name}
            </div>
            <img src={githubLogo} alt="GitHub" className="w-5 h-5" />
          </>
        ) : (
          <>
            <div
              className={`mr-1  ${hoverArrow === true ? "" : "text-gray-5"}`}
            >
              {name}
            </div>
            <ArrowRight
              className={`transition-transform duration-300 ease-in-out ${
                hoverArrow === true ? "translate-x-2 " : ""
              }`}
            />
          </>
        )}
      </a>
    </div>
  );
}

export default LinKProjectItem;
